import _find from "lodash/find";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Spacer from '../../structure/Spacer/Spacer';
import PhoneNumber from '../../text/PhoneNumber/PhoneNumber';
import { ContactContext } from '../../../providers';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const legalRenderer = form => {
  switch (form) {
    case 'single':
      return ___EmotionJSX(FormattedMessage, {
        id: "components.templates.legalSidebar.owner"
      });
    case 'ev':
      return 'Vertretungsberechtigte Vorstände:';
    case 'bag':
      return 'Berufsausübungsgemeinschaft der Vertragsärzte';
    default:
      return ___EmotionJSX(FormattedMessage, {
        id: "components.templates.legalSidebar.representedBy"
      });
  }
};
export const addressTypeRenderer = type => {
  switch (type) {
    case 'hq':
      return 'Hauptgeschäftsstelle';
    case 'federal_office':
      return 'Bundesgeschäftsstelle';
    default:
      return;
  }
};
function LegalSidebar() {
  return ___EmotionJSX(ContactContext.Consumer, null, context => {
    const address = context.addresses[0];
    const email = _find(context.emails, email => email.primary);
    const phoneNumber = _find(context.numbers, number => (number.type === 'phone' || number.type === 'mobile') && number.primary);
    const faxNumber = _find(context.numbers, number => number.type === 'fax' && number.primary);
    return ___EmotionJSX(S.Aside, null, ___EmotionJSX("section", null, ___EmotionJSX("h4", null, context.company_name), address.address_type && ___EmotionJSX("i", null, addressTypeRenderer(address.address_type)), ___EmotionJSX(Spacer, {
      height: 10
    }), ___EmotionJSX("p", null, address.street, " ", address.number), ___EmotionJSX("p", null, address.zip_code, " ", address.city), ___EmotionJSX(Spacer, {
      height: 10
    }), ___EmotionJSX("b", null, legalRenderer(context.legal_form)), context.executives.map(_ref => {
      let {
        name
      } = _ref;
      return ___EmotionJSX("div", {
        key: name
      }, name);
    })), ___EmotionJSX("section", null, ___EmotionJSX("h4", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.contactHeader"
    })), phoneNumber && ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.tel"
    }), " ", ___EmotionJSX(PhoneNumber, {
      number: phoneNumber.number,
      callable: false
    })), faxNumber && ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.fax"
    }), " ", ___EmotionJSX(PhoneNumber, {
      number: faxNumber.number,
      title: 'Fax',
      callable: false
    })), email && ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.email"
    }), " ", email.email)), context.registers.map(register => ___EmotionJSX("section", {
      key: register.register_type
    }, ___EmotionJSX("h4", null, register.register_type), ___EmotionJSX("p", null, register.number), ___EmotionJSX("p", null, register.registrar))), context.ust_id && ___EmotionJSX("section", null, ___EmotionJSX("h4", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.ustHeader"
    })), ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.ustDescr"
    }), " ", ___EmotionJSX("span", {
      style: {
        whiteSpace: 'nowrap'
      }
    }, context.ust_id))), context.vat_number && ___EmotionJSX("section", null, ___EmotionJSX("h4", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.tax"
    })), ___EmotionJSX("p", null, ___EmotionJSX(FormattedMessage, {
      id: "components.templates.legalSidebar.tax"
    }), " ", context.vat_number)));
  });
}
export default LegalSidebar;